import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: '[copy]',
  standalone: false,
  'host': {
    '(click)': 'doCopy()'
  }
})
export class Copy {
  readonly copy=input<string>(null);
  readonly copyMsg=input<string>(null);
  readonly msg=computed(() => this.copyMsg() ?? 'Copié');

  constructor(){ }

  async doCopy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.copy());
      alert(this.msg());
    } catch(error){
      alert('Erreur de copie');
    }
  }
}
